import React from 'react';
import useTrackingEvents from '../../../../helpers/useTrackingEvents';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import { Switch } from 'antd';
import CameraGlyph from '../../../../assets/icons/Glyph/CameraGlyph';

type OptionsSwitchPhotoButtonProps = {
  value: boolean;
  inspectionGroupName: string;
  inspectionGroupID: string;
  onChange: (checked: boolean) => void;
};

export function DroppableHeaderOptionsSwitchPhotoButton({
  value,
  onChange,
  inspectionGroupName,
  inspectionGroupID
}: OptionsSwitchPhotoButtonProps) {
  const { textColor } = useDroppableHeaderContext();
  const { track: trackingEvent } = useTrackingEvents();
  const handleSwitch = () => {
    const messageToEvent = value ? 'Disabled' : 'Enabled';
    trackingEvent(`${messageToEvent} mandatory photo when edit inspection group`, {
      inspectionGroupName,
      inspectionGroupID
    });
    onChange(!value);
  };

  return (
    <div className='drag-header__options_row gap-8'>
      <Switch
        data-testid='inspection-group-header-switch'
        style={{ borderRadius: '100px' }}
        checked={value}
        onChange={handleSwitch}
        onClick={(_, e) => e.stopPropagation()}
      />
      <CameraGlyph />
      <span className={`${textColor} mr-5`}>Mandatory photo for sampling</span>
    </div>
  );
}
